/* ============================================================
   SK shared state — minimal cross-section event bus.
   Sections dispatch and listen to window CustomEvents:
     sk:plan-change   detail: { plan: 'lifestyle'|'performance'|'recovery' }
     sk:size-change   detail: { size: 5|10|15, index: 0|1|2 }
   No globals beyond the window event surface. Each section is
   self-contained; this file is just convenience so the same
   late-init pattern doesn't get re-written everywhere.
   ============================================================ */
(function () {
  if (window.SK) return;

  var state = { plan: 'lifestyle', sizeIndex: 0, sizes: [5, 10, 15] };

  window.SK = {
    get plan() { return state.plan; },
    get sizeIndex() { return state.sizeIndex; },
    get size() { return state.sizes[state.sizeIndex]; },

    setPlan: function (plan) {
      if (state.plan === plan) return;
      state.plan = plan;
      window.dispatchEvent(new CustomEvent('sk:plan-change', { detail: { plan: plan } }));
    },

    setSizeIndex: function (idx) {
      if (state.sizeIndex === idx) return;
      state.sizeIndex = idx;
      window.dispatchEvent(new CustomEvent('sk:size-change', { detail: { size: state.sizes[idx], index: idx } }));
    },

    onPlanChange: function (fn) {
      window.addEventListener('sk:plan-change', function (e) { fn(e.detail.plan, e); });
      fn(state.plan, null);
    },

    onSizeChange: function (fn) {
      window.addEventListener('sk:size-change', function (e) { fn(e.detail.size, e.detail.index, e); });
      fn(state.sizes[state.sizeIndex], state.sizeIndex, null);
    }
  };
})();
